import {getTheme, ITheme, Panel, PanelType} from '@fluentui/react';
import React from 'react';
import {withTranslation, WithTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import SplitPane, {Pane} from 'react-split-pane';
import history from '../../history';
import {messageService} from '../../services/messageService';
import ConfirmationDialog from '../../shared/confirmationDialog/confirmationDialog';
import {getContractingUnit, getProject} from '../../shared/util';
import {pmolFormData, ProjectMolecule} from '../../types/projectMolecule';
import {BookMarkItem} from '../../types/template';
import '../style/style.css';
import CommandBarLeft from './commandBar/commandBarLeft';
import CommandBarRight from './commandBar/commandBarRight';
import DocumentPane from './documentPane/container';
import DocumentPaneSection from '../../shared/mainUI/documentPaneSection/documentPaneSection';
import withMainUI from '../../shared/mainUI/withMainUI';
import ListPane from './listPane/container';
import ListPaneSection from '../../shared/mainUI/listPaneSection/component';
import ShortCutPane from './shortCutPane/container';
import {getFilterQRCodes} from './../../reducers/templateReducer';
import {
    clearFormData,
    filterStockListPaneData,
    readByStockId,
    readStockDropDownData,
    readStockShortCutPaneData,
} from '../../reducers/stockReducer';
import {POListItem} from '../../types/purchaseOrder';
import {Warehouse} from '../../types/warehouse';
import {Sorter, StockShortCutPaneItem, StockShortCutPaneMain, StockShotcutPaneFilter} from '../../types/stock';
import {readWarehouseTaxonomy} from '../../reducers/warehouseReducer';
import {resizerStyle} from '../../shared/customStyle/commonStyles';

export const SHORTCUTPANE_ALL = null;
export const SHORTCUTPANE_STOCK_ID = 2;

export interface State {
  selectedShortCutItem: StockShotcutPaneFilter;
  filter: StockShotcutPaneFilter;
  filterModified: StockShotcutPaneFilter,
  formData: ProjectMolecule;
  loading: boolean;
  showPanel: boolean;
  width: number;
  activeClass: string;
  bookmarkDivClass: string;
  showDetails: boolean;
  autoSave: boolean;
  isEdit: boolean;
  isDisableNewButton: boolean;
  isDrag: boolean;
  resetLayout: boolean;
  collapseBookmarkPane: boolean;
  reSizer: number;
  projectId: null | string;
  showProgressBar: boolean;
  requestSent: boolean;
}

interface Props extends WithTranslation {
  match: any;
  resetFormData: () => void;
  showProgressBar: boolean;
  shortCutPaneFilters: StockShortCutPaneItem[];
  formData: any;
  setUid: () => void;
  clearUid: () => void;
  resetIsChange: () => void;
  uid: string | null;
  autoSave: boolean;
  isChange: boolean;
  isEdit: boolean;
  isDataLoaded?: boolean;
  loadMsg: string;
  location: any;
  loading: boolean;
  handleShowDocumentPane: (collapseBookmarkPane?: boolean) => void;
  reSizer: number;
  collapseBookmarkPane: boolean;
  showDetails: boolean;
  showPanel: boolean;
  handleScroll: () => void;
  currentActiveSection: string;
  animation: any;
  getFilterQRCodes: (filter: StockShotcutPaneFilter) => void;
  readStockShortCutPaneData: () => void;
  filterStockListPaneData: any;
  readStockDropDownData: () => void;
  readByStockId: (id: string) => void;
  clearFormData: () => void;
  shortcutPaneData: StockShortCutPaneMain;

  stockList: POListItem[];
  wearhouseTaxonomy: Warehouse[];
  isSTOCKListLoaded: boolean;
  stockDropDowns: any;
  reloadListPane: boolean;
  readWarehouseTaxonomy: (data: any) => void;
  isExpand: boolean;
}

class StockMainLayout extends React.Component<Props, State> {
  _isMounted = false;
  theme: ITheme = getTheme();
  subscription: any;

  bookmarkList: BookMarkItem[] = [
    {
      id: 1,
      link: 'stock-header',
      label: this.props.t('stockHeader'),
    },
    {
      id: 2,
      link: 'stock-history',
      label: this.props.t('stockHistory'),
    },
    {
      id: 3,
      link: 'history',
      label: this.props.t('history'),
    },
  ];

  constructor(props: Props) {
    super(props);
    this.state = {
      filter: new StockShotcutPaneFilter(),
      filterModified: new StockShotcutPaneFilter(),
      selectedShortCutItem: {
        id: null,
        title: null,
        name: null,
        type: null,
        status: null,
        wharehouseTaxonomy: null,
        wareHouse: null,
        sorter: new Sorter(),
        typeId: null,
        resourceType: null,
      },
      isEdit: false,
      autoSave: false,
      loading: false,
      width: window.innerWidth,
      showPanel: false,
      activeClass: 'grid-righter column-filter-activated',
      bookmarkDivClass: 'bookmark-panel parent',
      showDetails: false,
      formData: pmolFormData,
      isDisableNewButton: false,
      isDrag: false,
      resetLayout: false,
      collapseBookmarkPane: false,
      reSizer: screen.width,
      projectId: null,
      showProgressBar: false,
      requestSent: false,
    };
  }

  componentDidMount() {
    // throw new Error('Count is 5. Error Occurred.');
    this.handleUrlChange();
    this.props.readStockDropDownData();
    this.props.readStockShortCutPaneData();
    this.props.filterStockListPaneData(new StockShotcutPaneFilter());
    this.props.readWarehouseTaxonomy({ wareHouseId: null });
    if (
      location.pathname.split('/').pop() === 'new' &&
      this.state.formData &&
      this.state.formData.id === null
    ) {
      this.createNew();
    }
    this.setState(
      {
        formData: this.props.formData,
      },
      this.props.handleShowDocumentPane,
    );
    this.subscription = messageService.getMessage().subscribe((data: any) => {
      if (data) {
        if (data.data.hideDocumentPane) {
          this.hideDocumentPane();
        }

        if (data.data.isNewStock) {
          this.createNew();
        }

        // if (
        //   data &&
        //   data.data &&
        //   data.data.hasOwnProperty('isLoadingPMOLData') &&
        //   data.data.isLoadingPMOLData
        // ) {
        //   this.setState({ isDisableNewButton: true });
        // } else if (
        //   data.data.hasOwnProperty('isLoadingPMOLData') &&
        //   !data.data.isLoadingPMOLData
        // ) {
        //   this.setState({ isDisableNewButton: false });
        // }
      }
    });
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (this.props.reloadListPane !== prevProps.reloadListPane && this.props.reloadListPane) {
      this.reloadListPaneItem();
    }
    if (this.props.match.url !== prevProps.match.url) {
      this.handleUrlChange(prevState.collapseBookmarkPane);
    }
    if (this.props.formData !== prevProps.formData) {
      this.setState({
        formData: this.props.formData,
      });
    }
    if (this.props.showProgressBar !== prevProps.showProgressBar) {
      this.setState({
        showProgressBar: this.props.showProgressBar,
      });
    }
    if (this.props.collapseBookmarkPane !== prevProps.collapseBookmarkPane) {
      this.setState({
        collapseBookmarkPane: this.props.collapseBookmarkPane,
      });
    }
    if (
      this.props.location &&
      this.props.location.state &&
      this.props.location.state?.stockSCFilter &&
      prevProps.location.state?.stockSCFilter != this.props.location.state?.stockSCFilter
    ) {
      if (this.props.location.state.stockSCFilter) {
        messageService.sendMessage({ selectedShortCutPaneItem: this.props.location.state.stockSCFilter.id });
        if (this.props.location.state?.stockSCFilter.id === SHORTCUTPANE_STOCK_ID || this.props.location.state?.stockSCFilter.id === SHORTCUTPANE_ALL) {
          this.setState(
            {
              filter: new StockShotcutPaneFilter(),
              selectedShortCutItem: this.props.location.state.stockSCFilter,
            },
            this.reloadListPaneItem,
          );
        } else {
          this.setState(
            {
              filter: { ...this.state.filter, resourceType: this.props.location.state?.stockSCFilter.id.trim() },
              selectedShortCutItem: this.props.location.state?.stockSCFilter,
            },
            this.reloadListPaneItem,
          );
        }
      }
    }
  }

  handleUrlChange(collapseBookmarkPane?: boolean) {
    let id = this.props.match.params.featureId ? this.props.match.params.featureId : null;
    let isNew = location.pathname.split('/').pop() === 'new';

    if (id && id != 'new') {
      this.setState(
        {
          isEdit: !!this.props.match.params.featureId,
          isDisableNewButton: id ? true : false,
        }, () => {
          this.props.handleShowDocumentPane(collapseBookmarkPane);
        });
      this.props.readByStockId(id);
    } else {
      this.setState(
        {
          isEdit: false,
          isDisableNewButton: false,
        }, () => {
          this.props.handleShowDocumentPane();
        });
    }
  }

  componentWillUnmount() {
    this.subscription.unsubscribe();
  }

  // 2. clear states in this method and save to state
  // 3. update redirect url
  createNew = (): void => {
    this.props.clearFormData();
    //this.props.setUid();
    let formData: any = {
      title: null,
      // ....
    };
    this.setState({
      formData: formData,
    });
    if (getContractingUnit() && !getProject()) {
      history.push(`/CU/${getContractingUnit()}/stock/new`);
    } else {
      history.push(`/CU/${getContractingUnit()}/project/${getProject()}/stock/new`);
    }
  };

  reloadListPaneItem = () => {
    const { name, ...result } = this.state.filter;
    this.props.filterStockListPaneData({ ...result, name: null });
  };

  renderShortCutPane = () => {
    return (
      <ShortCutPane
        projectId={this.state.projectId}
        shortCutPaneFilters={this.props.shortcutPaneData}
        filter={this.state.filter}
        handelShortCutPaneFilter={(selectedItem: StockShotcutPaneFilter) =>
          this.handelShortCutPaneFilter(selectedItem)
        }
        toggleOverlay={this.state.collapseBookmarkPane}
        resetLayout={this.state.resetLayout}
        isExpand={this.state.collapseBookmarkPane}
      />
    );
  };

  getDocumentPaneView = () => {
    return (
      <DocumentPaneSection
        collapseBookmarkPane={this.state.collapseBookmarkPane}
        showProgress={this.props.showProgressBar}
        handleScroll={this.props.handleScroll}
        isEdit={this.props.isEdit}
        formData={this.state.formData}
        bookmarkList={this.bookmarkList}
        currentActiveSection={this.props.currentActiveSection}
        renderCommandBar={() => <CommandBarRight/>}
      >
        <DocumentPane
          // projectHeader= {{}}
          stockDropDowns={{}}
          //saveFormData={ (data: any) => {}}
          //getAllProjectDropdowns={ () => {}}
          //isLoadingStock={ false}
          //stockID={ null}
          //readByStockId={ (id: string) => {}}
          formData={this.props.formData}
          isExpand={this.state.collapseBookmarkPane}
          isNewStock={false}

        />
      </DocumentPaneSection>
    );
  };

  private getListPaneView = () => {
    return (
      <ListPaneSection
        activeClass={this.state.activeClass}
        titlePaneHeader={
          (this.state.selectedShortCutItem && this.state.selectedShortCutItem.name)
            ? this.state.selectedShortCutItem.name!!
            : 'All'
        }
        showProgress={this.props.showProgressBar}
        renderCommandBar={() => <CommandBarLeft disable={false}/>}
        renderShotcutPane={() => this.renderShortCutPane()}
      >
        <ListPane
          projectId={this.state.projectId}
          loadMsg={this.props.loadMsg}
          reloadListPaneItem={() => this.reloadListPaneItem()}
          filter={this.state.filter}
          listPaneItems={this.props.stockList}
          isDataLoaded={this.props.isSTOCKListLoaded}
          isChange={this.props.isChange}
          formData={this.state.formData}
          handelFilter={(filter: StockShotcutPaneFilter) =>
            this.handleFilter(filter)
          }
          handleSelectedListPaneItem={(
            selectedListItemIds: [] | string[],
          ) => {
            //this.handleSelectedListPaneItem(selectedListItemIds);
          }}
          reSizer={this.props.reSizer}
        />
      </ListPaneSection>
    );
  };

  handleFilter = (filter: StockShotcutPaneFilter) => {
    if ((filter.title && filter.title.length >= 3) || filter.title === null) {
      let filterModified = filter;
      this.setState({
        filter: filter,
        filterModified: filterModified,
      }, this.reloadListPaneItem);
      // const { name, ...result } = filterModified;
      // this.props.filterStockListPaneData({...result, name:null}).then((res:any)=>{
      //   //this.setState({requestSent:false})
      // })
    } else {
      this.setState({
        filter: filter,
      });
    }
  };

  handelShortCutPaneFilter = (selectedItem: StockShotcutPaneFilter) => {
    this.setState({
      selectedShortCutItem: selectedItem,
    });
  };

  render() {
    const { t } = this.props;
    return (
      <div>
        <div className={'ms-Grid'}>
          <SplitPane
            className={'SplitPane'}
            split="vertical"
            minSize={300}
            maxSize={screen.width / 2}
            defaultSize={
              this.props.showDetails ? screen.width / 2 : screen.width
            }
            resizerStyle={resizerStyle}
            style={{ height: 'calc(100vh - 129px)' }}
            size={this.props.reSizer}
            onDragStarted={() => {
              this.setState({
                // isDrag:true,
                // collapseBookmarkPane:true,
                // resetLayout:false,
              });
            }}
            onResizerDoubleClick={() => {
              this.setState({
                reSizer: this.props.reSizer === 300 ? screen.width / 2 : 300,
                isDrag: !this.state.isDrag,
                collapseBookmarkPane: !this.state.collapseBookmarkPane,
                resetLayout: !this.state.resetLayout,
              });
            }}
            onDragFinished={(newSize: number) => {
              this.setState({
                // isDrag:false,
                // resetLayout:false,
                reSizer: newSize,
                collapseBookmarkPane: newSize < screen.width / 2,
              });
            }}
            onChange={(newSize: number) => {
              if (newSize === screen.width / 2) {
                this.setState({
                  resetLayout: true,
                  collapseBookmarkPane: false,
                });
              }
            }}
          >
            <Pane className={'SplitPane'}>{this.getListPaneView()}</Pane>
            <Pane className={'SplitPane'}>
              {this.props.showDetails && (
                <div
                  className={`${this.props.animation(this.props.showDetails)}`}
                  style={{
                    display: this.props.showDetails ? 'block' : 'none',
                    transition: 'all 0.9s linear',
                  }}
                >
                  {!this.props.showPanel && (
                    <div>{this.getDocumentPaneView()}</div>
                  )}
                </div>
              )}
            </Pane>
          </SplitPane>
        </div>
        <Panel
          isOpen={this.props.showPanel}
          type={PanelType.smallFixedFar}
          onDismiss={this._hidePanel}
          isLightDismiss={true}
          headerText={t('corporateProductCatalogue')}
          className="custom-detail-panel"
          closeButtonAriaLabel={t('close')}
        >
          {this.getDocumentPaneView()}
        </Panel>

        <ConfirmationDialog
          hidden={true}
          title={t('areyousure')}
          subText={t('youwonTbeabletorevertthis')}
          onClickConfirmDialog={() => {
          }}
          onClickCancelDialog={() => {
          }}
          cancelButtonText={t('noIwonT')}
          confirmButtonText={t('yesDeleteit')}
        />
      </div>
    );
  }

  private _hidePanel = () => {
    this.setState({ showPanel: false, showDetails: false });
    if (getContractingUnit() && getProject()) {
      history.push(`/CU/${getContractingUnit()}/project/${getProject()}/stock`);
    } else if (getContractingUnit()) {
      //history.push(`/template`);
      history.push(`/CU/${getContractingUnit()}/stock`);
    }
  };

  private hideDocumentPane = () => {
    if (getContractingUnit() && getProject()) {
      history.push(`/CU/${getContractingUnit()}/project/${getProject()}/stock`);
    } else if (getContractingUnit()) {
      //history.push(`/template`);
      history.push(`/CU/${getContractingUnit()}/stock`);
    }
  };
}

const mapStateToProps = (state: any, ownProps: any) => {
  return {
    shortcutPaneData: state.stock?.stockShortCutPaneData,
    isSTOCKListLoaded: state.stock.isSTOCKListLoaded,
    stockList: state.stock.stockList,
    stockDropDowns: state.stock.stockDropDowns,
    reloadListPane: state.stock.reloadListPane,
    formData: state.stock.formData,
    showProgressBar: state.stock.showProgressBar,
    isEdit: state.stock.isEdit,

  };
};

const mapDispatchToProps = {
  getFilterQRCodes,
  readStockShortCutPaneData,
  filterStockListPaneData,
  readStockDropDownData,
  readByStockId,
  clearFormData,
  readWarehouseTaxonomy,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withTranslation()(withMainUI((StockMainLayout))),
  ));
